import Api from "./Api"
import { entityStore, configStore, EntityV2Store, creditControlStore } from "./CommonState"
const ENTITYURI = {
    LIST: `${process.env.REACT_APP_API_SERVER}/api/v1/entity`,
    GET: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/${id}`,
    GETENTITYWITHUSER: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/entitywithuser/${id}`,
      GETEMAILPREFERENCES: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/emailpreferences/${id}`,
    GETENTITYFORUSER: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/entityforuser/${id}`,
    PUT: `${process.env.REACT_APP_API_SERVER}/api/v1/entity`,
    UPDATE_EMAIL_PREFERENCES: `${process.env.REACT_APP_API_SERVER}/api/v1/entity/emailpreferences`,
    POST: `${process.env.REACT_APP_API_SERVER}/api/v1/entity`,
    CREATEFORUSER: (email) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/addforuser/${email}`,
    CHANGE: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/entity/change/${id}`,
    GET_FILE_CONFIG:`${process.env.REACT_APP_API_SERVER}/api/v1/entity/fileconfig/standard`,
      GET_FILE_BY_ENTITY:(id)=>`${process.env.REACT_APP_API_SERVER}/api/v1/entity/fileconfig/${id}`,
    UPDATE_FILE_CONFIG:`${process.env.REACT_APP_API_SERVER}/api/v1/entity/fileconfig/update`,
    GETCREDITCONTROL: `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getCreditControl`,
    GETCUSTOMERLIST : `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/entitygetCustomersList`
}
export default class EntityApi {
    static isCreditControlLoading = false
    static getCreditControl(callback = f => f) {
        if (this.isCreditControlLoading) return
        this.isCreditControlLoading = true
        Api.fetch(ENTITYURI.GETCREDITCONTROL, (data) => {
            this.isCreditControlLoading = false
            let res = data?.results || data || []
            if (JSON.stringify(creditControlStore.list) !== JSON.stringify(res)) {
                creditControlStore.list = JSON.parse(JSON.stringify(res))
            }
            callback(res)
        }, () => {
            this.isCreditControlLoading = false
        })
    }
    static getList(callback = f => f) {
        Api.fetch(ENTITYURI.LIST, (data) => {
            if (JSON.stringify(EntityV2Store.list) !== JSON.stringify(data)) {
                EntityV2Store.list = data  
                EntityV2Store.Cuslist= data.filter((r,i) => {
                    if(r.entityType === "Customer" || (r.entityType === "Vendor" && r?.vendor?.isChannelPartner==true)){
                        return true
                    }else{
                        return false
                    }
                })
            }
            callback(data)
        })
    }
    static getEntity(id,callback=f=>f) {
        Api.fetch(ENTITYURI.GET(id), (data) => {
            entityStore.entityRec.set(data)
            if(callback){
            callback(data)
            }else {
                return data
            }
        })
    }
      static filesbyentity(entityId) {
    return new Promise((resolve, reject) => {
        Api.fetch(
            ENTITYURI.GET_FILE_BY_ENTITY(entityId),
            (data) => {
                resolve(data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
   static getFileConfig() {
    return new Promise((resolve, reject) => {
        Api.fetch(
            ENTITYURI.GET_FILE_CONFIG,
            (data) => {
                resolve(data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
 static updateFileConfig(body) {
    return new Promise((resolve, reject) => {
        Api.post(
            ENTITYURI.UPDATE_FILE_CONFIG,
            body,
            (data) => {
                configStore.setModalMessage('Entity file config Saved');
                resolve(data); 
            },
            (err) => {
                reject(err);
            }
        );
    });
}
   static async getEmailPreferences(id) {
  return new Promise((resolve, reject) => {
    Api.fetch(ENTITYURI.GETEMAILPREFERENCES(id), (data, err) => {
      if (err) return reject(err);
      resolve(data);
    });
  });
}

    static getEntityWithUser(id,callback=f=>f) {
        Api.fetch(ENTITYURI.GETENTITYWITHUSER(id), (data) => {
          callback(data)
        })
    }
    static saveEntity() {
        console.log('about to call api.put')
        Api.put(ENTITYURI.PUT, entityStore.entityRec, (data) => {
            configStore.setModalMessage('Entity Details Saved')
        })
    }
     static updateEmailPreferences(payLoad) {
  return new Promise((resolve, reject) => {
    Api.put(ENTITYURI.UPDATE_EMAIL_PREFERENCES, payLoad, (data, err) => {
      if (err) {
        reject(err);
      } else {
        resolve(data);
      }
    });
  });
}

    static saveGivenEntity(entity) {
        console.log('about to call api.put')
        Api.put(ENTITYURI.PUT, entity, (data) => {
            //configStore.setModalMessage('Entity Details Saved')
        })
    }
    static createEntity() {
        console.log('about to call api.post')
        Api.post(ENTITYURI.POST, entityStore.entityRec, (data) => {
            configStore.setModalMessage('Entity Details Saved')
        })
    }
    static createEntityForUser(email, entity, callback=f=>f) {
        console.log('about to call api.post')
        Api.post(ENTITYURI.CREATEFORUSER(email), entity, (data) => {
            configStore.setModalMessage('New Entity created')
            callback(data)
        })
    }
    static changeEntity(id) {
        Api.fetch(ENTITYURI.CHANGE(id), (data) => {
            
        })
    }

    static EntityListForUser(id , callback) {
        Api.fetch(ENTITYURI.GETENTITYFORUSER(id), (data) => {
            callback(data)
        })
    }

    static getcustomerList (callback){
        Api.fetch1(ENTITYURI.GETCUSTOMERLIST , (data)=> {
             callback(data)
        })
    }
}